import * as SelectPrimitive from '@radix-ui/react-select';
import clsx from 'clsx';
import { forwardRef } from 'react';
import type { ComponentPropsWithoutRef, ElementRef } from 'react';

import { composeRefs } from '@app/hooks/compose-refs';

import { useInternalSelectContext } from './context';

import style from './select-compound.module.scss';

const SelectContent = forwardRef<
  ElementRef<typeof SelectPrimitive.Content>,
  Omit<ComponentPropsWithoutRef<typeof SelectPrimitive.Content>, 'position'>
>(({ className, children, ...props }, ref) => {
  const { contentRef } = useInternalSelectContext();

  const composedRefs = composeRefs(ref, contentRef);

  return (
    <SelectPrimitive.Portal>
      <SelectPrimitive.Content
        ref={composedRefs}
        position="popper"
        className={clsx(style.SelectContent, className)}
        {...props}
      >
        <SelectPrimitive.Viewport>{children}</SelectPrimitive.Viewport>
      </SelectPrimitive.Content>
    </SelectPrimitive.Portal>
  );
});
SelectContent.displayName = SelectPrimitive.Content.displayName;

export { SelectContent };
